import React from "react";
import { Tabs, Tab } from "@nextui-org/react";
import { useSidebarStore } from "../components/sidebar/MainSidebar";
import SharedWithMeFolders from "src/components/shared_files/shared_with_me/SharedWithMeFolders";
import SharedByMeFolders from "src/components/shared_files/shared_by_me/SharedByMeFolders";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "src/store/api/useAuthStore";
import DownloadList from "src/components/common/DownloadList";
import useFolderStore from "src/store/api/useFolderStore";
import { useSharedStore } from "src/store/layout/useSharedStore";
import { useClubStore } from "src/store/api/useClubStore";

const Shared: React.FC = () => {
  const { t } = useTranslation();
  const isSaff = useAuthStore((state) => state.isSaff);
  const isClub = useAuthStore((state) => state.isClub);

    
const userIsSaff = isSaff && !isClub;
console.log("userIsSaff: ",userIsSaff);
console.log("isSaff: ",isSaff);
console.log("isClub: ",isClub);
  // Active tab state
  const { activeKey, setActiveKey } = useSharedStore();
  const { setActiveTab } = useSidebarStore.getState(); // Fetching latest folderId
  const { emptyFolderStack } = useFolderStore();

  // Handler for tab change
  const handleTabChange = (key: string) => {
    emptyFolderStack();

    setActiveKey(key); // Update active tab
    if (key === "1") setActiveTab("SharedWithMe");
    else setActiveTab("SharedByMe");
  };

  return (
    <>
      <div className="text-[33px] capitalize text-navy-700 mt-4 mb-5">
        <div className="font-bold capitalize hover:text-navy-700">
          {t("SharedFiles")}
        </div>
      </div>

      <div className="max-sm:hidden">
        <DownloadList />
      </div>

      {/* Tabs */}
      <Tabs
        variant="underlined"
        aria-label="Shared Tabs"
        selectedKey={activeKey}
        onSelectionChange={(key) => handleTabChange(key as string)} // Cast to string
      >
        <Tab key="1" title={t("SharedWithMe")}>
          <SharedWithMeFolders />
        </Tab>
        {userIsSaff && (
          <Tab key="2" title={t("SharedByMe")}>
            <SharedByMeFolders />
          </Tab>
        )}
      </Tabs>
    </>
  );
};

export default Shared;
